<template>
  <div class="paypal-cancel">
    <h1>Pagamento PayPal annullato</h1>

    <div v-if="loading" class="status">⏳ Elaboro l'annullamento…</div>

    <div v-else-if="success" class="status info">
      ℹ️ Il pagamento è stato annullato. L'ordine resta in attesa solo se non era già pagato.<br />
      <span v-if="message">{{ message }}</span>
    </div>

    <div v-else class="status error">
      ❌ Errore durante l'annullamento.<br />
      <code>{{ error }}</code>
    </div>
  </div>
</template>

<script>
import { getPayPalFunctionUrl } from '@/lib/env';

export default {
  name: 'PayPalCancel',
  data() {
    return {
      loading: true,
      success: false,
      error: null,
      message: '',
    };
  },
  methods: {
    getQueryInsensitive(name) {
      const q = this.$route?.query || {};
      if (q[name] != null) return q[name];
      const wanted = name.toLowerCase();
      const k = Object.keys(q).find(key => key.toLowerCase() === wanted);
      return k ? q[k] : null;
    },
  },
  async mounted() {
    try {
      const orderId = this.getQueryInsensitive('orderId');
      if (!orderId) {
        throw new Error('Parametro orderId mancante.');
      }

      const fnUrl = getPayPalFunctionUrl('cancel');
      if (!fnUrl) {
        throw new Error('Endpoint cancel PayPal non configurato');
      }

      const res = await fetch(fnUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ orderId }),
      });

      if (!res.ok) {
        const errTxt = await res.text().catch(() => '');
        throw new Error(`Errore HTTP ${res.status}: ${errTxt}`);
      }

      const payload = await res.json().catch(() => ({}));
      if (payload?.success) {
        if (payload?.skipped === 'already-paid') {
          this.message = 'Il pagamento risultava già completato, nessuna modifica all\'ordine.';
        } else if (payload?.skipped === 'approval-cancelled') {
          this.message = 'Pagamento gift interrotto. La gift resta in attesa di pagamento e non è stata accreditata.';
        } else if (payload?.skipped === 'under-review') {
          this.message = 'Il team sta verificando il pagamento della gift. Contatta team@fusco.fit per assistenza.';
        } else {
          this.message = 'L\'ordine è stato segnato come cancellato.';
        }
        this.success = true;
        const next = this.getQueryInsensitive('next');
        if (next && String(next).startsWith('/checkout/')) {
          setTimeout(() => {
            this.$router.replace(String(next));
          }, 900);
        }
      } else {
        throw new Error(payload?.error || 'Risposta inattesa dal server.');
      }
    } catch (err) {
      this.error = err?.message || String(err);
    } finally {
      this.loading = false;
    }
  },
};
</script>

<style scoped>
.paypal-cancel {
  max-width: 600px;
  margin: 4rem auto;
  padding: 2rem;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  text-align: center;
  font-family: sans-serif;
}
.status {
  margin-top: 1rem;
  font-size: 1.1rem;
}
.info {
  color: #0f172a;
}
.error {
  color: red;
  font-weight: bold;
}
</style>
